<footer>
    <div class="container">
        <div class="grid-x">
            <div class="large-12">
                <div class="contact-list">
                    <span>Copyright © {{ currentYear }} The Piano Workshop.</span>
                    <span>For all enquiries please contact Aidan on <a href="tel:+447747135213">07747 135213</a></span>
                    <span><a href="mailto:aidansimms@yahoo.co.uk" target="_blank" rel="noopener"><i class="fa-solid fa-envelope"></i></a></span>
                    <span><a href="https://www.facebook.com/thepianoworkshop.co.uk/" target="_blank" rel="noopener"><i class="fa-brands fa-facebook"></i></a></span>
                    <span><a href="https://www.instagram.com/the.piano.workshop/" target="_blank" rel="noopener"><i class="fa-brands fa-instagram"></i></a></span>
                </div>
            </div>
        </div>
    </div>
</footer>

